import React from 'react';

// Stylized "U" letterform with subtle green accent
const Logo = ({ size = 40, className = '' }) => (
  <svg 
    width={size} 
    height={size} 
    viewBox="0 0 48 48" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Uro2Go logo"
  >
    {/* Circular background */}
    <circle 
      cx="24" 
      cy="24" 
      r="22" 
      fill="#0B5D6E"
    />
    
    {/* Stylized U shape */}
    <path 
      d="M14 12V24C14 30.6 18.5 36 24 36C29.5 36 34 30.6 34 24V12"
      stroke="#ffffff"
      strokeWidth="5"
      strokeLinecap="round"
      fill="none"
    />
    
    {/* Subtle accent line at bottom curve */}
    <path 
      d="M18 28C18 32 20.7 34 24 34C27.3 34 30 32 30 28"
      stroke="#4CAF93"
      strokeWidth="2.5"
      strokeLinecap="round"
      fill="none"
    />
  </svg>
);

export default Logo;
